// Simple localStorage-based admin token auth
import axios from "axios";

const TOKEN_KEY = "7med_admin_token";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export function getToken() {
    try {
        return localStorage.getItem(TOKEN_KEY);
    } catch {
        return null;
    }
}

export function setToken(token) {
    try {
        if (token) localStorage.setItem(TOKEN_KEY, token);
        else localStorage.removeItem(TOKEN_KEY);
    } catch (err) {
        console.warn("Auth token storage unavailable:", err?.message || err);
    }
}

export function logout() {
    setToken(null);
}

export function isAuthenticated() {
    return !!getToken();
}

export async function login(email, password) {
    const { data } = await axios.post(`${API}/auth/login`, { email, password }, {
        headers: { "Content-Type": "application/json" },
        timeout: 15000,
    });
    setToken(data.access_token);
    return data;
}

export async function verifyToken() {
    const token = getToken();
    if (!token) return null;
    try {
        const { data } = await axios.get(`${API}/auth/me`, {
            headers: { Authorization: `Bearer ${token}` },
            timeout: 10000,
        });
        return data;
    } catch {
        setToken(null);
        return null;
    }
}

export function formatApiErrorDetail(detail) {
    if (detail == null) return "Si è verificato un errore. Riprova.";
    if (typeof detail === "string") return detail;
    if (Array.isArray(detail)) return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" · ");
    if (detail && typeof detail.msg === "string") return detail.msg;
    return String(detail);
}
